export function animationWorker(input, texts) {
    this.input = input;
    this.texts = texts;
    this.curTextNum = 0;
    this.animationFrameId = 0;
    this.animationActive = false;
    this.singleStateList = [0,1]
    this.singleState = 0

    this.animate = () => {
        if(!this.animationActive) return;
        if(this.singleState === 0 ) {
            this.input.innerHTML =  this.texts[this.curTextNum];
            this.curTextNum = (this.curTextNum +1) % this.texts.length
        }
        let cls = "frame" + this.singleStateList[this.singleState]
        this.input.setAttribute("class", cls)
        this.singleState = (this.singleState + 1)% this.singleStateList.length

        let timeout = 2000;
        setTimeout(
            () => { if(this.animationActive) this.animationFrameId = window.requestAnimationFrame(this.animate)},
            timeout);
    }

    this.stop = () => {
        this.animationActive = false;
        window.cancelAnimationFrame(this.animationFrameId);
    }

    this.start = () => {
        this.animationActive = true;
        this.animationFrameId = window.requestAnimationFrame(this.animate);
        return this;
    }
}
